import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import Formulario from "../../../Componentes/Utils/Formulario";
import FormComp from "../../../Componentes/FormComp";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader";
import { useModal } from "../../../contexts/ModalContext";
import { useAmbienteMedicao } from "../../../contexts/AmbienteMedicaoContext";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";
import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";

const DISCIPLINAS = [
    "ELÉTRICA",
    "INSTRUMENTAÇÃO",
    "ESTRUTURA METÁLICA",
    "ISOLAMENTO TÉRMICO",
    "PARAFUSOS E FIXAÇÃO",
    "TUBULAÇÃO",
    "LOCAÇÃO",
    "OUTRO",
];

const toCaixaAlta = (str) => (typeof str === "string" ? str.toLocaleUpperCase("pt-BR") : str);

const AnexosLabel = styled.h3`
    margin: 20px 0 10px;
    font-size: 16px;
    color: #555;
    text-align: center;
`;

const ModalAdicionarPCFaturamentoDireto = ({ onSalvo }) => {

    const { id } = useParams();
    const { closeModal } = useModal();
    const { ambiente } = useAmbienteMedicao();
    const { notifySuccess, notifyError } = useToast();
    const api = useApi();

    const [saving, setSaving] = useState(false);

    const [formValues, setFormValues] = useState({
        disciplina: "",
        disciplinaOutro: "",
        numPedidoFornecedor: "",
        nomeFornecedor: "",
        data: "",
        valorPedido: 0,
    });

    const [arquivos, setArquivos] = useState([]);

    const handleChange = (e) => {

        const { name, value } = e.target;

        if (name === "valorPedido") {
            setFormValues((prev) => ({ ...prev, [name]: parseCentsFromInput(value) }));
            return;
        }

        if (name === "disciplina") {
            const v = toCaixaAlta(value);
            setFormValues((prev) => ({
                ...prev,
                disciplina: v,
                disciplinaOutro: v === "OUTRO" ? prev.disciplinaOutro : "",
            }));
            return;
        }

        setFormValues((prev) => ({
            ...prev,
            [name]: typeof value === "string" ? toCaixaAlta(value) : value,
        }));

    };

    const disciplinaEhOutro = formValues.disciplina === "OUTRO";

    const handleSalvar = async (e) => {

        e.preventDefault();

        const disciplinaFinal = disciplinaEhOutro
            ? toCaixaAlta(formValues.disciplinaOutro.trim())
            : formValues.disciplina;

        if (!formValues.disciplina) {
            notifyError("Selecione a disciplina.");
            return;
        }

        if (disciplinaEhOutro && !formValues.disciplinaOutro.trim()) {
            notifyError("Informe a disciplina quando a opção for OUTRO.");
            return;
        }

        if (!disciplinaFinal) {
            notifyError("Disciplina inválida.");
            return;
        }

        if (formValues.valorPedido <= 0) {
            notifyError("O valor do pedido deve ser maior que zero.");
            return;
        }

        setSaving(true);

        try {

            const formData = new FormData();
            formData.append("id_pc", id);
            formData.append("disciplina", disciplinaFinal);
            formData.append("num_pedido_fornec", toCaixaAlta(formValues.numPedidoFornecedor.trim()));
            formData.append("fornecedor", toCaixaAlta(formValues.nomeFornecedor.trim()));
            formData.append("valor", String(formValues.valorPedido));

            await api.post("/Painel/API/ControleMedicao/SavePcFaturamentoDireto/", formData);

            notifySuccess("Registro salvo com sucesso.");
            closeModal();
            if (typeof onSalvo === "function") {
                await onSalvo();
            }

        } catch (err) {

            const msg = err?.response?.data?.message || "Erro ao salvar. Tente novamente.";
            notifyError(typeof msg === "string" ? msg : "Erro ao salvar. Tente novamente.");
            console.error(err);

        } finally {

            setSaving(false);

        }

    };

    return (
        <Overlay state={true}>
            <Modal header close={closeModal}>
                <Formulario onSubmit={handleSalvar}>
                    <FormComp
                        title="OBRA"
                        type="text"
                        readOnly
                        valor={toCaixaAlta(ambiente?.descricao ?? "")}
                    />
                    <FormComp
                        title="DISCIPLINA"
                        type="select"
                        options={DISCIPLINAS}
                        valor={formValues.disciplina}
                        name="disciplina"
                        changeFunc={handleChange}
                        required
                    />
                    {disciplinaEhOutro && (
                        <FormComp
                            title="ESPECIFIQUE A DISCIPLINA"
                            type="text"
                            valor={formValues.disciplinaOutro}
                            name="disciplinaOutro"
                            changeFunc={handleChange}
                            required
                        />
                    )}
                    <FormComp
                        title="N PEDIDO / FORNECEDOR"
                        type="text"
                        valor={formValues.numPedidoFornecedor}
                        name="numPedidoFornecedor"
                        changeFunc={handleChange}
                        required
                    />
                    <FormComp
                        title="NOME FORNECEDOR"
                        type="text"
                        valor={formValues.nomeFornecedor}
                        name="nomeFornecedor"
                        changeFunc={handleChange}
                        required
                    />
                    <FormComp
                        title="DATA"
                        type="date"
                        valor={formValues.data}
                        name="data"
                        changeFunc={handleChange}
                        required
                    />
                    <FormComp
                        title="VALOR DO PEDIDO"
                        type="text"
                        inputMode="numeric"
                        placeholder="R$ 0,00"
                        valor={formatBRLFromCents(formValues.valorPedido)}
                        name="valorPedido"
                        changeFunc={handleChange}
                        required
                    />
                    <AnexosLabel>CAMPO DE ANEXOS</AnexosLabel>
                    <MultiFileUploader
                        files={arquivos}
                        setFiles={setArquivos}
                    />
                    <FormComp
                        type="submit"
                        valor={saving ? "SALVANDO..." : "SALVAR"}
                        disabled={saving}
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );

};

export default ModalAdicionarPCFaturamentoDireto;
